import { configApp } from 'core/config/environment-variables';
import { RoutePaths } from 'core/models';
import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

const useProtocolHandler = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const url = searchParams.get('url');

  useEffect(() => {
    if (!url) {
      navigate(RoutePaths.Dashboard);
      return;
    }

    const urlWithoutPrefix = url.replace(`${configApp.protocolHandler}://`, '');
    const [page, id] = urlWithoutPrefix.split('/');

    if (!id) {
      navigate(`/${page}`);
      return;
    }
    switch (page) {
      case RoutePaths.Assets:
        navigate(`/${RoutePaths.Assets}/${id}/${RoutePaths.AssetDetailProductInfomation}`);
        break;
      case RoutePaths.Companies:
        navigate(`/${RoutePaths.Companies}/${id}`);
        break;
      default:
        navigate(`/${RoutePaths.NotFound}`);
    }
  }, [navigate, url]);
};

export default useProtocolHandler;
